import { useSelector } from 'react-redux'
import { getUserProfile } from 'src/redux/store/profile'

export function useProfile() {
  return useSelector(getUserProfile)
}
